import { Button, CircularProgress } from "@mui/material";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import avatarimage from '../../Assets/Images/avatar.jpg';
import person1 from '../../Assets/Images/image1.jpg';
import person2 from '../../Assets/Images/feedback-image-2.jpg';
import person3 from '../../Assets/Images/feedback-image-3.jpg';
import star from '../../Assets/Images/star.svg'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import hideicon from "../../Assets/Images/hideicone.svg"
import showicon from "../../Assets/Images/showIcon.svg"
import { useContext, useState, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
// import Logo from '../../Assets/Images/logo.png';
import TPLogo from '../../Assets/Images/TPLogo.png';
import NewTPLogo from '../../Assets/Images/whiteLogo.png';

import { createCustomer, fetchOrganisationDetails, fetchPaymentMethodId, fetchSavedCards } from "../../api";
import { TokenContext } from "../../Context/TokenContext";

const Login = () => {

  useEffect(() => {
    localStorage.clear()
  }, [])

  const authCtx = useContext(AuthContext)

  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoginIn, setIsLoginIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const { setSelectedToken } = useContext(TokenContext)

  const formLink = () => {
    navigate("/first-form/" + id + "?" + searchParams, { replace: true });
  }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 14000,
  };

  const [hidetoggle, settoggle] = useState(true);
  const [chidetoggle, csettoggle] = useState(true);
  const [data, setData] = useState({
    email: '',
    password: '',
    // confirmPassword: '',
    emailError: '',
    passwordError: '',
    // confirmPasswordError: '',
  });
  const [error, showError] = useState(false)

  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );

  useEffect(() => {
    if (authCtx.isLoggedIn) {
      navigate('/dashboard');
    }
  }, [authCtx.isLoggedIn, navigate]);


  const passwordShow = () => {
    settoggle(!hidetoggle);
  }

  const confpasswordShow = () => {
    csettoggle(!chidetoggle);
  }

  const handleChange = (event) => {
    event.preventDefault();
    showError(false)
    const { name, value } = event.target;

    switch (name) {
      case 'email':
        setData((prev) => ({ ...prev, emailError: validEmailRegex.test(value) ? '' : 'Please enter a valid email address.' }));
        break;
      case 'password':
        setData((prev) => ({ ...prev, passwordError: value?.trim()?.length === 0 ? "Please enter your password." : '' }));
        break;
      // case 'confirmPassword':
      //   setData((prev) => ({ ...prev, confirmPasswordError: value !== data.password ? 'Password did not match!' : '' }));
      //   break;
      default:
        break;
    }

    setData((prev) => ({ ...prev, [name]: value }));
  }

  console.log('TokenContext', TokenContext)

  const validateForm = () => {
    return (
      data.email.length > 0 && data.password.length > 0 && data.emailError.length === 0 && data.passwordError.length === 0 );
  }

  const handleSignIn = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (data.email.length === 0 || data.password.length === 0) {
        showError(true);
        if (data.email === "" && data.password.trim().length === 0) {
          setData((prev) => ({ ...prev, emailError: "Please enter a valid email address.", passwordError: "Please enter your password.", }));
        }
        return;
      }

      try {
        showError(false);
        const response = await loginHandler(data.email, data.password);

        if (response.success) {
          localStorage.clear();
          const { token, userId, orgId, userName, email, scope, tokenExpiration, orgStatus } = response.data;
          const username = userName

          authCtx.login(token, userId, orgId, username, email, scope, tokenExpiration);

          if (orgId) {
            try {
              let orgData = await fetchOrganisationDetails(orgId);
              // console.log("Fetched organization data:", orgData);

              if (orgData && orgData.data && (orgData.status?.toLowerCase() === 'success' || orgData.data.status?.toLowerCase() === 'active')) {
                setErrorMessage("");
                // const username = email.split("@")
                const normalizedEmail = email?.trim().toLowerCase() || "";
                const data = await createCustomer(normalizedEmail, username[0], orgId)

                if (data.status === 'success') {
                  authCtx?.addCustomerId(data?.customerId)
                  console.log('orgData?.data?.accountIdentifier', orgData?.data)
                  const paymentMethodId = await fetchSavedCards(data?.customerId, token)
                  authCtx?.addPaymentMethodId(paymentMethodId[0]?.id)
                  console.log("paymentMethodId", paymentMethodId[0]?.id)

                // no need to readd payment mehtod if already added.
                  if (paymentMethodId[0]?.id || orgData?.data?.stripeCustomerId) {
                    navigate("/dashboard")
                  } else if(orgStatus !== 'active'){

                    navigate(`/signup-details/${orgId}?returning=true` , {
                      state: {
                      fromLoginPage: true
                      }
                    }) 

                  } else   {
                    navigate(`/signup-payment/${orgId}?returning=true`, {
                      state: {
                        fromLoginPage: true
                      }
                    })
                    }

                  // if (orgData?.data?.stripeCustomerId) {
                  //   console.log("customerID stripeCustomerId", orgData?.data?.stripeCustomerId)
                  //   navigate("/dashboard")
                  // } else {
                  //   console.log("customerID not there stripeCustomerId", orgData?.data?.stripeCustomerId)
                  //   navigate("/signup-payment", {
                  //     state: {
                  //       fromLoginPage: true
                  //     }
                  //   })
                  // }
                }
                } else {
                  // console.log("Condition failed:", orgData?.data?.status);
                  setErrorMessage("Your account is not active. Please complete the payment to activate your account.");
                }
              } catch (e) {
                console.error("Error fetching organization data:", e);
                setErrorMessage("An error occurred while verifying your account. Please try again later.");
              }
            } else {
              setErrorMessage(""); // Clear any leftover error message
              navigate("/dashboard");
            }
          }
        } catch (error) {
          console.error("Login failed:", error);
          showError(true);
          setData((prev) => ({
            ...prev,
            emailError: "",
            passwordError: "",
          }));
          const message = error.message || "The password is incorrect. Please try again.";
          setErrorMessage(message.trim().endsWith('.') ? message : message + '.');
        }
      } else {
        showError(true);
      }

      console.log("authCtx", authCtx)
    };

    const loginHandler = (email, password) => {
      setIsLoginIn(true);
      const normalizedEmail = email?.trim().toLowerCase() || "";

      return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URI}/v4/organisation/login`, {
          method: "POST",
          mode: "cors",
          headers: { 
            "Content-Type": "application/json" 
          },
          body: JSON.stringify({
            email: normalizedEmail,
            password,
            assessmentId: parseInt(process.env.REACT_APP_CLIENT_ID)
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.token) {
              const tokenExpiration = new Date(new Date().getTime() + 86400000);
              
              resolve({
                success: true,
                data: {
                  token: data.token,
                  userId: data.userId,
                  orgId: data.orgId,
                  userName: data.fullName || "",
                  email: email,
                  scope: data?.scope,
                  tokenExpiration: tokenExpiration,
                  orgStatus: data?.orgStatus
                },
              });
              setIsLoginIn(false);
            } else {
              reject(
                new Error(
                  data.message || "The password is incorrect. Please try again."
                )
              );
              setIsLoginIn(false);
            }
          })
          .catch((err) => {
            setIsLoginIn(false);
            reject(
              new Error(
                "Failed to connect to the server. Please try again later."
              )
            );
          }).finally(() => {
            setIsLoginIn(false);
          });
      });
    };

    const login = (e) => {
      e.preventDefault();
      navigate('/dashboard')
    }

    const navigateSignUp = (e) => {
      e.preventDefault();
      navigate('/signup', {
        state: {
          fromLoginPage: true
        }
      })
    }

    const navigateForgotPassword = (e) => {
      e.preventDefault();
      navigate('/forget-password')
    }

    return (
      <div className="container login-container">
        <div className="inner-container">
          <div className="left">
              <img src={NewTPLogo} alt="Logo" style={{ width: "113", height: "129" , objectFit: "contain"}} />
            <h1>Welcome to the <br /> Quadrant Flow Portal  </h1>
          </div>
          <div className="right">
            <form className="form">
              <h2>Log In</h2>
              <div className="input-box">
                <label htmlFor="email">Email<span className="asterisk-mark">*</span></label>
                <input type="email" name="email" id="email" placeholder="Type your email here" value={data.email} onChange={(e) => handleChange(e)} />
                {error && data.emailError && <div className='form-error'>{data.emailError}</div>}
              </div>
              <div className="input-box">
                <label htmlFor="password">Password<span className="asterisk-mark">*</span></label>
                <div className="input-wrapper">
                  <input type={hidetoggle ? "password" : "text"} name="password" id="password" value={data.password} onChange={(e) => handleChange(e)} placeholder="Type your password" />
                  <img src={hidetoggle ? hideicon : showicon} alt={hidetoggle ? "Hide password" : "Show password"} onClick={passwordShow} className="toggle-icon" role="button" aria-label="Toggle password visibility" />
                </div>
                {(error && data.passwordError) ?
                  <div className='form-error'>{data.passwordError}</div> :
                  (errorMessage && <p className="error-message">{errorMessage}</p>)}
              </div>
              <button disabled={isLoginIn} type="button" onClick={handleSignIn}>
                {isLoginIn ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Log In"}
              </button>
              <div className="form-footer">
                <p>Don't have an account? <span onClick={(e) => navigateSignUp(e)} ><span>Sign up</span></span></p>
                <p>Forgot your password? <span onClick={(e) => navigateForgotPassword(e)}><span>Click here</span></span></p>
              </div>
            </form>

          </div>
        </div>
        {/* <div className="login-form">
        <h1>LogIn</h1>
        <form>
          <div className={`input-box ${data.emailError ? 'error' : ''}`}>
            <label htmlFor="email">Email*</label>
            <input
              type="email"
              value={data.email}
              name='email'
              onChange={(e) => handleChange(e)}
              // placeholder='example@gmail.com' 
              />
            {error && data.emailError.length > 0 ? <div className='form-error'>{data.emailError}</div> : null}
          </div>

          <div className={`input-box ${data.passwordError ? 'error' : ''}`}>
            <label htmlFor="password">Password*</label>
            <input
              type={hidetoggle ? "password" : "text"}
              name="password"
              id="password"
              value={data.password}
              onChange={(e) => handleChange(e)}
            />
            <img src={hidetoggle ? hideicon : showicon} alt="hideicon" onClick={passwordShow} className="hideicon" />
            {error && data.passwordError.length > 0 ? <div className='form-error'>{data.passwordError}</div> : null}
          </div>

          <button onClick={handleSignIn} className={`login-button`}>
            {
              isLoginIn ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Sign In"
            }
          </button>
          <div className="form-footer">Don't have an account? <Link to="/signup">Sign up</Link></div>
        </form>
      </div> */}
        {/* <Slider {...settings} style={{ width: "50%", maxWidth: '428px' }}>
        <div>
          <div className="login-testimonial">
            <div className="avatar-img">
              <img src={person1} alt="" />
            </div>
            <div className="stars-container">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
            </div>
            <div className="testimonial">"Cultivating a vocationally informed church requires knowing and understanding your congregation thoroughly. With Scatter, our leadership team could gather this information swiftly and, more importantly, in an organized manner. This helped us plan and implement new priorities and practices that minister to and engage our congregants' daily lives. "</div>
            <div className="testimonial-details">
              <div className="name">TIM PARKER | <span className="designation">ROCK CHURCH, LEAD PASTOR</span></div>
            </div>
          </div>
        </div>
        <div>
          <div className="login-testimonial">
            <div className="avatar-img">
              <img src={person2} alt="" />
            </div>
            <div className="stars-container">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
            </div>
            <div className="testimonial">"Breaking away from generational patterns to cultivate and nourish a church that is flourishing at work, outside our church engagements, is no tiny task. With a reasonably large congregation, it seemed only more impossible to tend to all. Scatter made it so quick to understand the composition of our congregation. We were able to dig out key insights to achieve our end."</div>
            <div className="testimonial-details">
              <div className="name">DAVE SMITH | <span className="designation">LIGHT CHURCH, LEAD PASTOR</span></div>
            </div>
          </div>
        </div>
        <div>
          <div className="login-testimonial">
            <div className="avatar-img">
              <img src={person3} alt="" />
            </div>
            <div className="stars-container">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
            </div>
            <div className="testimonial">"Our leadership team can view just 1 dashboard and make decisions to better curate opportunities to nurture our congregation according to its specific needs and talents."</div>
            <div className="testimonial-details">
              <div className="name">MATT ROSE | <span className="designation">FAITH FELLOWSHIP, LEAD PASTOR</span></div>
            </div>
          </div>
        </div>

      </Slider> */}
      </div>
    )
  }

  export default Login;
